import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { DateInvioAtto } from "../models/date-invio-atto";
import { ResourcefulService } from "./resourcefulService";

@Injectable({
  providedIn: "root",
})
export class DateInvioAttoService extends ResourcefulService<DateInvioAtto> {
  constructor(httpClient: HttpClient) {
    super(httpClient, DateInvioAtto);
  }

  listByIncarico(incaricoId: number): Promise<DateInvioAtto[]> {
    const params: any = {
      incarico_id: `${incaricoId}`,
    };

    return this._httpClient
      .get<{ data: any[] }>(`${this.baseUrl}/${DateInvioAtto.apiUrl}`, {
        params,
      })
      .pipe(
        map((response) =>
          (response?.data || []).map((item) =>
            new DateInvioAtto().deserialize(item)
          )
        )
      )
      .toPromise();
  }
}
